import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * converts a number of days to a human readable format:  like '10 days', '7.5 weeks', '3 months'
 */

@NgFilter({
    token: Token.LeadTimeFilter,
    dependencies: [
    ]
})
export class LeadTimeFilter {
    constructor() {
        return ((days: number, singular: boolean = false) => {
            if (days < 14) {
                return days + " " + (singular ? loc.day : loc.days);
            } else if (days < 90) {
                return (days / 7).rounder(1).toString() + " " + (singular ? loc.week : loc.weeks);
            } else {
                return (days / 30.42).rounder(1).toString() + " " + (singular ? loc.month : loc.months);
            }
        }) as any;
    }
}
